import { FilterConditionOutput } from '@shared/components/ui/AdvancedFilter';
import { FiltersDropdown } from '@shared/components/ui/FiltersDropdown';
import { Search } from '@shared/components/ui/Search';
import { ColumnSelector } from '@shared/components/ui/ColumnSelector';
import { ChangeEvent, useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ExtraWorkOrdersFiltersPanel } from './ExtraWorkOrdersFiltersPanel';

interface FiltersSectionProps {
  handleSearch: (value: string) => void;
  onFilterChange?: (conditions: FilterConditionOutput[]) => void;
  allColumns: any[];
  selectedColumns: string[];
  onColumnsChange: (columns: string[]) => void;
  fixedColumns?: string[];
  exportColumns: string[];
  searchTerm: string;
  filterConditions: FilterConditionOutput[];
}

export const FiltersSection = ({
  handleSearch,
  onFilterChange,
  allColumns,
  selectedColumns,
  onColumnsChange,
  fixedColumns = [],
  exportColumns,
  searchTerm,
  filterConditions,
}: FiltersSectionProps) => {
  const { t } = useTranslation('extraWorkOrdersModule');
  const [inputValue, setInputValue] = useState(searchTerm);

  const activeFiltersCount = useMemo(() => filterConditions.length, [filterConditions.length]);

  useEffect(() => {
    setInputValue((prev) => (prev === searchTerm ? prev : searchTerm));
  }, [searchTerm]);

  const handleFilterChange = useCallback(
    (conditions: FilterConditionOutput[]) => {
      onFilterChange?.(conditions);
    },
    [onFilterChange],
  );

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  const handleSearchSubmit = () => {
    const trimmedValue = inputValue.trim();
    handleSearch(trimmedValue);
  };

  return (
    <>
      <Search
        placeholder={t('filters.search_placeholder', 'Buscar por referencia...')}
        value={inputValue}
        onChange={handleInputChange}
        onEnter={handleSearchSubmit}
        dataTestId="search"
        inputDataTestId="search-input"
      />
      <FiltersDropdown
        title={t('filters.title', 'Filtros')}
        activeFiltersCount={activeFiltersCount}
        triggerTestId="filters-toggle-button"
      >
        <ExtraWorkOrdersFiltersPanel initialConditions={filterConditions} onChange={handleFilterChange} />
      </FiltersDropdown>
      <ColumnSelector
        columns={allColumns}
        selected={selectedColumns}
        onColumnsChange={onColumnsChange}
        fixedColumns={fixedColumns}
        storageKey="extra-work-orders-list"
        dataTestId="extra-work-orders-column-selector"
      />
    </>
  );
};
